import script from "./deviceDuplicateRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceDuplicateRecord.vue?vue&type=script&setup=true&lang=js"

import "./deviceDuplicateRecord.vue?vue&type=style&index=0&id=28acdd94&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28acdd94"]])

export default __exports__